import { render } from "./Workbooks.vue?vue&type=template&id=4335a304&scoped=true"
import script from "./Workbooks.vue?vue&type=script&lang=js"
export * from "./Workbooks.vue?vue&type=script&lang=js"

import "./Workbooks.vue?vue&type=style&index=0&id=4335a304&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4335a304"],['__file',"src/views/post/Workbooks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4335a304"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4335a304', __exports__)) {
    console.log('reload')
    api.reload('4335a304', __exports__)
  }
  
  module.hot.accept("./Workbooks.vue?vue&type=template&id=4335a304&scoped=true", () => {
    console.log('re-render')
    api.rerender('4335a304', render)
  })

}


export default __exports__